'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _constants = require('redux/constants');

var _catalog = require('redux/actions/catalog');

var _modal_type = require('redux/actions/modal_type');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Header: {
        displayName: 'Header'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Search/Search.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Header = _wrapComponent('Header')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        theme: state.setting.theme,
        searchProducts: state.catalog.searchProducts,
        closeSearch: state.catalog.closeSearch,
        orderInOneClick: state.setting.orderInOneClick,
        loyaltySettingsActive: state.setting.loyaltySettingsActive,
        user: state.auth.user,
        lang: state.lang
    };
}, { push: _reactRouterRedux.push, setSearchClose: _catalog.setSearchClose, showCouponSearchModal: _modal_type.showCouponSearchModal }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Header, _Component);

    function Header(props) {
        (0, _classCallCheck3.default)(this, Header);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props));

        _this.handleEnter = function (e) {
            if (e.key === 'Enter') {
                _this.handleClick(e);
            }
        };

        _this.handleClick = function (e) {
            e.preventDefault();
            if (_this.state.inputState.length > 0) {
                _this.props.push('/search/' + _this.state.inputState + '?limit=' + _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT + '&page=' + 1);
            }
        };

        _this.handleChangeInput = function (value) {
            _this.setState({ inputState: value });
        };

        _this.handleSelect = function (value) {
            _this.setState({ inputState: value });
            _this.props.push('/search/' + _this.state.inputState + '?limit=' + _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT + '&page=' + 1);
        };

        _this.onFindCoupon = function (e) {
            _this.props.showCouponSearchModal(_this.props.lang);
        };

        _this.state = {
            inputState: ''
        };
        return _this;
    }

    (0, _createClass3.default)(Header, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.closeSearch) {
                //Сброс инпута после выхода со страницы поиска
                this.setState({ inputState: '' }, function () {
                    _this2.props.setSearchClose(false);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('Search');

            return _react3.default.createElement(View, {
                handleClick: this.handleClick,
                handleEnter: this.handleEnter,
                handleChangeInput: this.handleChangeInput,
                inputState: this.state.inputState,
                onSelect: this.handleSelect,
                theme: this.props.theme,
                searchProducts: this.props.searchProducts,
                lang: this.props.lang,
                onFindCoupon: this.onFindCoupon,
                loyaltySettingsActive: this.props.loyaltySettingsActive
            });
        }
    }]);
    return Header;
}(_react2.Component), _class2.propsType = {
    theme: _react2.PropTypes.string.isRequired,
    lang: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/Search.jsx
// module id = 1764
// module chunks = 0